import { Link } from '@tanstack/react-router';

const tabs = [
  { to: '/components/colors', label: '✓ Brand Colors' },
  { to: '/components/typography', label: '✓ Typography' },
  { to: '/components/iconography', label: '✓ Iconography' },
  { to: '/components/tables', label: '✓ Components' },
  { to: '/components/wizards', label: 'Wizards' },
  { to: '/components/buttons', label: '✓ Buttons' },
  { to: '/components/forms', label: '✓ Forms' },
  { to: '/components/animations', label: '✓ Animations' },
];

export function ComponentTabs() {
  return (
    <div className="border-b border-gray-200 mb-6">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => (
          <Link
            key={tab.to}
            to={tab.to}
            className="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm text-gray-700 hover:text-gray-900 hover:border-gray-300 border-transparent"
            activeProps={{
              className: 'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm text-[#290BD9] border-[#290BD9]'
            }}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
